import { BASE_URL } from "../../request";
import { tickerValidator } from "../../globalVariables";

/**
 * Created by mongoose on 8/11/17.
 */

export default {
  name: "Filters",
  entityName: "filter",
  restConfig: {
    baseURL: `${BASE_URL}`,
    create: {
      url: () => `/api/filters`,
      method: "post",
      resetCache: true,
    },
    update: {
      url: () => "/api/filters",
      method: "put",
      resetCache: true,
    },
    fetch: {
      url: ({ hotelTicker, id }) => `/api/filters/${hotelTicker}/${id ? id : ""}`,
      method: "get",
    },
    fetchSingle: {
      url: ({ entity }) => `/api/filters/${entity.hotelTicker}/${entity.id}`,
      method: "get",
    },
    delete: {
      url: ({ hotelTicker, id }) => `/api/filters/${id}`,
      method: "delete",
      resetCache: true,
    },
    upload: {
      url: ({ hotelTicker }) => `/api/filters/${hotelTicker}/file`,
      method: "post",
      resetCache: true,
    },
    download: {
      url: ({ hotelTicker }) => `/api/filters/${hotelTicker}/file`,
      method: "get",
    },
  },
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "filterTranslations",
  },
  fields: {
    list: [
      //columns to be used in the table/list display, Order IS important
      {
        fieldName: "active",
        displayName: "Is active?",
        widget: "singleSwitch",
        toggleAction: true,
      },
      {
        fieldName: "id",
        displayName: "id",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "representationType",
        displayName: "Type",
      },
    ],
    form: [
      //fields to be used in the creation/edit form display, Order IS important
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "Hotel Ticker",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Active",
        widget: "checkbox",
        description: "Is the filter active?",
        helpText: "Check whether this filter applies or not.",
        defaultValue: false,
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        widget: "input",
        readOnly: true,
      },

      {
        fieldName: "representationType",
        displayName: "Type",
        widget: "selector",
        optionDisplay: {
          DROPDOWN: {
            label: "Dropdown",
          },
          RADIO: {
            label: "Radio",
          },
          TAB: {
            label: "Tab",
          },
        },
        defaultValue: "DROPDOWN",
      },
      {
        fieldName: "name",
        displayName: "Name",
        widget: "input",
        translated: true,
      },
      {
        fieldName: "description",
        displayName: "Description",
        widget: "textarea",
        translated: true,
      },

      {
        fieldName: "filterOptions",
        displayName: "Filter Options",
        widget: "nestedEntity",
        nested: true,
        entityName: "FilterOption",
        sortName: "filterOptionPosition",
        defaultValue: [],
      },
    ],
  },
  validation: {
    id: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    hotelTicker: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    active: {
      type: "Boolean",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    ticker: tickerValidator,
    representationType: {
      type: "Enum",
      constraints: {
        inclusion: {
          within: ["DROPDOWN", "RADIO", "TAB"],
        },
        presence: {
          allowEmpty: false,
        },
      },
      defaultValue: "DROPDOWN",
    },
    name: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    description: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: true,
        },
      },
    },
    filterOptions: {
      type: "String",
      constraints: {},
    },
  },
};
